import React, { useState } from 'react';

export default function Headers(){
  
  return(
    <header className='header'>
      <h1>Taylor Tours and Travels</h1>
      <button className='btn'>Book Now</button>
    </header>
  )
}